import { PlanType } from '@dtx-company/true-common/src/types/planType'

const orgPlanTypes = [PlanType.PRO_PLUS_ORG, PlanType.PRO_FLEX, PlanType.PILOT, PlanType.ENTERPRISE]

/**
 * Indicates if a given planType is for an org.
 *
 * Org plans require an org name on purchase and may have seats.
 *
 * All plans will be org plans in the future.
 */
export function isOrgPlan(
  planType: PlanType
): planType is PlanType.PRO_PLUS_ORG | PlanType.PRO_FLEX | PlanType.PILOT | PlanType.ENTERPRISE {
  return orgPlanTypes.includes(planType)
}
